import React, {useEffect, useReducer, useState} from 'react';
import {Form} from '../../../../stores/Form/Form';
import {automationReducer, AutomationReducerType} from '../../reducer';
import {AutomationContext} from '../../context';
import {useAutomationContextAPI} from './hooks/useAutomationContextAPI';
import {AutomationContextType, defaultContext as initialContext} from '../../reducer/model';
import {AutomationModuleView} from './view';
import {getServerTexts} from '../../texts';
import {getServerTexts as getEmailServerTexts} from '../../../EmailEditor/texts';
import {getServerTexts as getAIServerTexts} from '../../../../Localization/AISearch/texts';

type Props = {
    form: Form;
    componentClasses?: string;
    defaultContext?: AutomationContextType;
    disabled?: boolean;
    macroSubmenu?: boolean;
};

export const AutomationsModule = (props: Props) => {
    const {form, componentClasses, disabled, macroSubmenu, defaultContext = initialContext} = props;
    const [useBridgeAPI] = useState(!form); // flag to switch between 2 APIs (old to new);
    // Initialize the state using useReducer
    const [state, dispatch] = useReducer<AutomationReducerType, AutomationContextType>(
        automationReducer,
        {...defaultContext, useBridgeAPI},
        arg => arg
    );

    const contextValue = {...state, useBridgeAPI};

    const contextHandlers = useAutomationContextAPI(dispatch, contextValue, form);

    useEffect(() => {
        (async () =>
            await Promise.all([getServerTexts(), getAIServerTexts(), getEmailServerTexts()]))();
    }, []);

    return (
        <AutomationContext.Provider
            value={{
                ...contextValue,
                ...contextHandlers
            }}
        >
            <AutomationModuleView
                form={form}
                componentClasses={componentClasses}
                disabled={disabled}
                macroSubmenu={macroSubmenu}
            />
        </AutomationContext.Provider>
    );
};
